import React from 'react';
import useAxios from 'axios-hooks';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import RoomIcon from '@material-ui/icons/Room';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import { Map } from '../components/Map';
import { IServedZone } from '../types/strapi';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
  },
  firstBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    color: '#fff',
    fontSize: 28,
    fontWeight: 600,
    padding: theme.spacing(2),
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
    '& .MuiTypography-colorTextSecondary': {
      color: '#fff',
    },
  },
  infoItemIcon: {
    color: '#fff',
  },
  infoDivider: {
    backgroundColor: '#fff',
  },
  map: {
    width: '60%',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  secondBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: '75%',
    position: 'relative',
    margin: '32px auto',
    borderRadius: '11px',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      width: '95%',
    },

    '& .topbar': {
      backgroundColor: '#fff',
      color: theme.palette.secondary.main,
      fontSize: 27,
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      padding: `0 ${theme.spacing(1)}px`,
      [theme.breakpoints.down('xs')]: {
        fontSize: 21,
      },
    },
    '& .number': {
      fontSize: 72,
      fontWeight: 'bold',
      margin: `0 ${theme.spacing(2)}px`,
    },
    '& .text': {
      height: '27px',
    },
    '& .content': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      padding: `${theme.spacing(3)}px`,
      '& > div': {
        width: '33.3%',
        margin: `${theme.spacing(1)}px 0`,
        fontSize: 20,
        fontWeight: 600,
        [theme.breakpoints.down('sm')]: {
          fontSize: 17,
        },
        [theme.breakpoints.down('xs')]: {
          width: '50%',
        },
      },
    },
  },
}));

const Contatti: React.FC = () => {
  const classes = useStyles();
  const [{ data: zones = [] }] = useAxios<IServedZone[]>(`served-zones`);

  const mainZones = zones.filter((zone) => !zone.mainZone).map((zone) => zone.name);

  return (
    <Container disableGutters className={classes.root}>
      <Box className={classes.firstBox}>
        <List className={classes.infoBox}>
          <ListItem>
            <ListItemIcon>
              <ShoppingBasketIcon className={classes.infoItemIcon} />
            </ListItemIcon>
            <ListItemText primary="Società Agricola L'orto Dei F.lli Compagnoni S.s." />
          </ListItem>
          <Divider className={classes.infoDivider} />
          <ListItem>
            <ListItemIcon>
              <RoomIcon className={classes.infoItemIcon} />
            </ListItemIcon>
            <ListItemText primary="Strada Statale Nord 208/A 41037 Tramuschio (MO)" />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <PhoneIphoneIcon className={classes.infoItemIcon} />
            </ListItemIcon>
            <ListItemText primary="339 540 8713" />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardTravelIcon className={classes.infoItemIcon} />
            </ListItemIcon>
            <ListItemText primary="P.Iva 03824940369" />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <AccessTimeIcon className={classes.infoItemIcon} />
            </ListItemIcon>
            <ListItemText primary="Orari" secondary="Lunedì-Sabato 9:00-12:30 15:30-19:00" />
          </ListItem>
        </List>
        <Box className={classes.map}>
          <Map />
        </Box>
      </Box>
      {mainZones.length && (
        <Box className={classes.secondBox}>
          <div className={classes.card}>
            <div className="topbar">
              <span className="number">{mainZones.length}</span>
              <span className="text">Le zone che serviamo</span>
            </div>
            <div className="content">
              {mainZones.map((name, i) => (
                <div key={i}>{name}</div>
              ))}
            </div>
          </div>
        </Box>
      )}
    </Container>
  );
};

export default Contatti;
